'use strict';
require('cookieconsent');
var defaultOptions = {
    // if false, this prevents the popup from showing (useful for giving to control to another piece of code)
    enabled: true,
    // defaults cookie options - it is RECOMMENDED to set these values to correspond with your server
    cookie: {
        // This is the name of this cookie - you can ignore this
        name: 'cvt_cookieconsent',
        // This is the domain that the cookie 'name' belongs to. The cookie can only be read on this domain.
        // Set this to empty string will use current domain, which should be suitable for most use cases,
        // unless sibling subdomains are in concern.
        //  - Guide to cookie domains - http://erik.io/blog/2014/03/04/definitive-guide-to-cookie-domains/
        domain: '',
        // This is a additional identifier for client app to differentiate apps under same domain.
        // eg. construct an event/account specific string if cookie consent is desired for each event or account.
        // NOTE: must not contain control/separator character. eg (CTL), space, tab, or ( ) < > @ , ; : \ " /  [ ] ? = { }
        identifier: '',
        // The cookies expire date, specified in days (specify -1 for no expiry)
        expiryDays: 365
    },
    // desired language for Cven Privacy Policy
    // accept language code, language-contry code, or MS language ID, according to RFC 3066,
    // NOTE: this is REQUIRED
    language: undefined,
    // each item defines the inner text for the element that it references
    // library does not provide default text as of now, client app should provide text with proper translation
    content: {
        // message: 'eg. We use cookies to provide you with a great browsing experience. By using Cvent, ' +
        //   'you accept our use of cookies for analytics and personalized content.',
        // dismiss: 'eg. Accept',
        // allow: 'eg. Accept',
        // deny: 'eg. Decline',
        // link: 'eg. Cvent Privacy Policy',
        href: 'http://www.cvent.com/en/privacy-policy.shtml#cookies',
        // default page with language selection
        close: '\uE935'
    },
    // select your type of popup here
    type: 'info',
    // refers to `compliance` (in other words, the buttons that are displayed)
    // this refers to the popup windows position. we currently support:
    position: 'bottom',
    // default position is 'bottom'
    // cookieconsent library internal theme options
    theme: 'classic',
    // default classic theme gives border radius
    // if you want custom colours, pass them in here. this object should look like this.
    // if prefered, any custom colours/themes can be created in a separate style sheet, as this is more efficient.
    //   {
    //     popup: {background: '#000000', text: '#fff', link: '#fff'},
    //     button: {background: 'transparent', border: '#f8e71c', text: '#f8e71c'},
    //     highlight: {background: '#f8e71c', border: '#f8e71c', text: '#000000'},
    //   }
    // `highlight` is optional and extends `button`. if it exists, it will apply to the first button
    // only background needs to be defined for every element. if not set, other colors can be calculated from it
    palette: {
        popup: {
            background: '#E9EDEF',
            text: '#3b4d54',
            link: '#0099e0'
        },
        button: {
            background: '#0099e0',
            text: '#f4f8f9'
        }
    },
    /**
     * call backs when user perform action (click button or auto dismiss)
     * valid cookie values
     * cc.status = {
     *   deny: 'deny',
     *   allow: 'allow',
     *   dismiss: 'dismiss'
     * };
    */
    onStatusChange: function onStatusChange(status, chosenBefore) { },
    // eslint-disable-line no-unused-vars
    // Some countries REQUIRE that a user can change their mind. You can configure this yourself.
    // Most of the time this should be false
    revokable: false,
    // used to disable link on existing layouts
    // replaces element messagelink with message and removes content of link
    showLink: true,
    elements: {
        messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}}<br />' + '<a role=button tabindex="0" class="cc-link" href="{{href}}" ' + 'rel="noopener nofollow" target="_blank">{{link}}</a></span>'
    },
    // layout options: 'basic': plain, 'basic-close': with close icon, 'basic-header': with header
    layout: 'basic-close',
    // dismiss banner when user click anything
    dismissOnWindowClick: true,
    // default to be true
    // The application automatically decide whether the popup should open.
    // Set this to false to prevent this from happening and to allow you to control the behaviour yourself
    autoOpen: true
};
/**
 * All supported languages with recognizable input
 */
var languages = {
    'en-US': {
        // RFC 3066 level 2 identifier, also browser language header
        language: 'en',
        // language subtag
        country: 'US',
        // country subtag
        cultureCode: 1033,
        // Microsoft culture code: https://msdn.microsoft.com/en-us/library/ee796272,
        commonName: 'English' // language name in common English
    },
    'da-DK': {
        language: 'da',
        country: 'DK',
        cultureCode: 1030,
        commonName: 'Danish'
    },
    'fr-FR': {
        language: 'fr',
        country: 'FR',
        cultureCode: 1036,
        commonName: 'French'
    },
    'it-IT': {
        language: 'it',
        country: 'IT',
        cultureCode: 1040,
        commonName: 'Italian'
    },
    'pl-PL': {
        language: 'pl',
        country: 'PL',
        cultureCode: 1045,
        commonName: 'Polish'
    },
    'es-ES': {
        language: 'ed',
        country: 'ES',
        cultureCode: 3082,
        commonName: 'Spanish'
    },
    'bg-BG': {
        language: 'bg',
        country: 'BG',
        cultureCode: 1026,
        commonName: 'Bulgarian'
    },
    'nl-NL': {
        language: 'nl',
        country: 'NL',
        cultureCode: 1043,
        commonName: 'Dutch'
    },
    'de-DE': {
        language: 'de',
        country: 'DE',
        cultureCode: 1031,
        commonName: 'German'
    },
    'lv-LV': {
        language: 'lv',
        country: 'LV',
        cultureCode: 1062,
        commonName: 'Latvian'
    },
    'ro-RO': {
        language: 'ro',
        country: 'ro',
        cultureCode: 1048,
        commonName: 'Romanian'
    },
    'sv-SE': {
        language: 'sv',
        country: 'SE',
        cultureCode: 1053,
        commonName: 'Swedish'
    },
    'sv-FI': {
        language: 'sv',
        country: 'FN',
        cultureCode: 2077,
        commonName: 'Swedish - Finland'
    },
    'hr-HR': {
        language: 'hr',
        country: 'HR',
        cultureCode: 1050,
        commonName: 'Croatian'
    },
    'et-EE': {
        language: 'et',
        country: 'EE',
        cultureCode: 1061,
        commonName: 'Estonian'
    },
    'el-GR': {
        language: 'el',
        country: 'GR',
        cultureCode: 1032,
        commonName: 'Greek'
    },
    'lt-LT': {
        language: 'lt',
        country: 'LT',
        cultureCode: 1063,
        commonName: 'Lithuanian'
    },
    'sk-SK': {
        language: 'sk',
        country: 'SK',
        cultureCode: 1051,
        commonName: 'Slovak'
    },
    'tr-TR': {
        language: 'tr',
        country: 'TR',
        cultureCode: 1055,
        commonName: 'Turkish'
    },
    'cs-CZ': {
        language: 'cs',
        country: 'CZ',
        cultureCode: 1029,
        commonName: 'Czech'
    },
    'fi-FI': {
        language: 'fi',
        country: 'FI',
        cultureCode: 1035,
        commonName: 'Finnish'
    },
    'hu-HU': {
        language: 'hu',
        country: 'HU',
        cultureCode: 1038,
        commonName: 'Hungarian'
    },
    'mt-MT': {
        language: 'mt',
        country: 'MT',
        cultureCode: 1082,
        commonName: 'Maltese'
    },
    'sl-SI': {
        language: 'sl',
        country: 'SI',
        cultureCode: 1060,
        commonName: 'Slovenian'
    }
};
var resolvedLanguage = function (input) {
    if (!input) {
        return undefined;
    }
    if (languages[input]) {
        return input;
    }
    for (var id in languages) {
        if (languages.hasOwnProperty(id)) {
            var identifier = languages[id];
            if (identifier.language === input || identifier.cultureCode === input || (identifier.cultureCode || '').toString() === input || typeof input === 'string' && identifier.commonName.toLowerCase() === input.toLowerCase()) {
                return id;
            }
        }
    } // fall back to language subtag only for not yet matched type 2 identifiers
    if (typeof input === 'string' && input[2] === '-') {
        var languageSubtag_1 = input.substr(0, 2);
        var matchByLanguageSubtag = Object.keys(languages).find(function (languageId) { return languageSubtag_1 === languageId.substr(0, 2); });
        if (matchByLanguageSubtag) {
            return matchByLanguageSubtag;
        }
    }
    return undefined; // no default match desired
};
/**
 * Cvent Privacy Policies per language
 */
var privacyPolicy = {
    'en-US': 'http://www.cvent.com/en/privacy-policy-global.shtml#cookies',
    'da-DK': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-danish.shtml#cookies',
    'fr-FR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-french.shtml#cookies',
    'it-IT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-italian.shtml#cookies',
    'pl-PL': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-polish.shtml#cookies',
    'es-ES': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-spanish.shtml#cookies',
    'bg-BG': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-bulgarian.shtml#cookies',
    'nl-NL': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-dutch-netherlands.shtml#cookies',
    'de-DE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-german.shtml#cookies',
    'lv-LV': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-latvian.shtml#cookies',
    'ro-RO': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-romanian.shtml#cookies',
    'sv-SE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-swedish.shtml#cookies',
    'sv-FI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-swedish.shtml#cookies',
    'hr-HR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-croatian.shtml#cookies',
    'et-EE': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-estonian.shtml#cookies',
    'el-GR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-greek.shtml#cookies',
    'lt-LT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-lithuanian.shtml#cookies',
    'sk-SK': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-slovakian.shtml#cookies',
    'tr-TR': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-turkish-cypress.shtml#cookies',
    'cs-CZ': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-czech.shtml#cookies',
    'fi-FI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-finnish.shtml#cookies',
    'hu-HU': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-hungarian.shtml#cookies',
    'mt-MT': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-maltese.shtml#cookies',
    'sl-SI': 'http://www.cvent.com/en/privacy-policy/privacy-policy-global-slovenian.shtml#cookies'
};
function index(config) {
    if (config === void 0) { config = {}; }
    // Disable auto-float on mobile feature of the library.
    // see: https://github.com/insites/cookieconsent/blob/master/src/cookieconsent.js#L648
    window.cookieconsent.utils.isMobile = function () { return false; };
    var effectiveConfig = window.cookieconsent.utils.deepExtend(defaultOptions, config); // unique identifier support
    effectiveConfig.cookie.name = effectiveConfig.cookie.name + '-' + effectiveConfig.cookie.identifier; // privacy policy languages support
    if (!config.language) {
        throw new Error('language is required to use cvent-cookieconsent');
    }
    if (!effectiveConfig.content.href) {
        var resolvedLanguage$$1 = resolvedLanguage(config.language);
        effectiveConfig.content.href = privacyPolicy[resolvedLanguage$$1] || effectiveConfig.content.href;
    }
    window.cookieconsent.initialise(effectiveConfig);
}
module.exports = index;
